import type { WatchDto, WatchStatus } from "@sitescene/types";

export type WatchlistAlertHitFilter = "any" | "none" | "one" | "two-plus";

export const WATCHLIST_SORT_COLUMNS = [
	"alerts",
	"createdDateTime",
	"status",
	"title",
] as const;

export type WatchlistSortColumn = (typeof WATCHLIST_SORT_COLUMNS)[number];

export type WatchlistSortDirection = "ascending" | "descending";

export const DEFAULT_WATCHLIST_SORT_COLUMN: WatchlistSortColumn =
	"createdDateTime";
export const DEFAULT_WATCHLIST_SORT_DIRECTION: WatchlistSortDirection =
	"descending";

export interface WatchlistFilters {
	alertHitFilter: WatchlistAlertHitFilter;
	/** Empty array means all locations. */
	locationFilter: string[];
	searchQuery: string;
	showArchived: boolean;
	sortColumn: WatchlistSortColumn;
	sortDirection: WatchlistSortDirection;
	statusFilter: null | WatchStatus;
}

export const DEFAULT_WATCHLIST_FILTERS: WatchlistFilters = {
	alertHitFilter: "any",
	locationFilter: [],
	searchQuery: "",
	showArchived: true,
	sortColumn: DEFAULT_WATCHLIST_SORT_COLUMN,
	sortDirection: DEFAULT_WATCHLIST_SORT_DIRECTION,
	statusFilter: null,
};

export enum EditWatchType {
	TimeframeMinutes = "timeframeMinutes",
	Title = "title",
}

export interface EditWatchModalProps {
	editType: EditWatchType | null;
	isOpen: boolean;
	onClose: () => void;
	watch: WatchDto;
}
